var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNodeJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#2E036A",
    strokeLinejoin: "round",
    strokeWidth: 17,
    d: "M244 0L455.31 122 455.31 366 244 488 32.69 366 32.69 122z",
    transform: "translate(31 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF597",
    d: "M244 35L424.999 139.5 424.999 348.5 244 453 63.001 348.5 63.001 139.5z",
    transform: "translate(31 32)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E036A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    d: "M128 161.104L222 107 222 391 144 344.172 144 296.252M350 154.999L262 107 262 237.643 350 237.643 350 337.969 262 389",
    transform: "translate(31 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNodeJs);
export default __webpack_public_path__ + "static/media/icon--node-js.76957cc996d84a86346b1d71358550b0.svg";
export { ForwardRef as ReactComponent };